'use client'

import cx from 'classnames'

import '@/components/Common/Cross/Cross.scss'

export default function Cross({ open }: { open: boolean }) {
  return (
    <>
      <figure
        className={cx('c-cross', {
          'c-cross--open': open,
        })}
      />
    </>
  )
}
